<template>
  <TrfSimpleModal :titulo="modalListagemTitulo" :isAtivo="modalListagemAtivo" @close="fecharModal" :isModalPersonalizado="true">
        <div id="conteudo-modal-cliente-listagem" class="modal-list-content pt-0" @scroll="TrfMixAderirAoInfiniteScroll" style="max-height:60vh; max-width:1024px; width:100%;">
        
          <button
            v-if="modalListagemFiltroStatus == statusEnum.CONCLUIDO"
            :disabled="this.listaDadosParaDownload.length == 0"
            class="button is-big mt-3 mb-5 px-2"
            type="button"
            @click="(event) => downloadDocumentoModalRecebidosTotalizador(event, listaDadosParaDownload)"
          >
            <i class="mdi mdi-download mdi-18px" aria-hidden="true"></i>
            Download Selecionado(s)
          </button>
          
          <TrfGlobalLoader type="overlay" v-if="isDocumentDownloading" />
         
          <TrfSimpleTable
            @checkbox-change="preencheArrayDocumentos"
            :configuracaoDeColunas="modalListagemFiltroStatus == statusEnum.CONCLUIDO ? listagemConfiguracaoTarefasClienteConcluidas : listagemConfiguracaoTarefasCliente" 
            :dados="modalListagemFiltroStatus == statusEnum.CONCLUIDO ? listagemDadosTratadosTarefasClienteConcluidas : listagemDadosTratados" 
            :isCliente="modalListagemFiltroStatus == statusEnum.CONCLUIDO"
            mensagemSemDados="Não há tarefas para este filtro." 
            class="trf-simple-table"
            id="table-cards"
            ref="tableCardsModal"
          >    
            
            <template #th>
                <th></th>
                <th></th>
            </template>
  
            <template v-if="modalListagemFiltroStatus == statusEnum.CONCLUIDO" #td="{ item }" >
              <td class="td-button pl-2">
                <a class="button" aria-haspopup="true" target="_blank" 
                  :href="`//${urlFrontEcontador}Documentos/Visualizar/${item.id}`" 
                  :class="`${item.arquivo ? '' : 'disabled'}`">
                  <span class="icon is-small">
                    <i class="mdi mdi-eye" aria-hidden="true"></i>
                  </span>
                  <span>Visualizar</span>
                </a>
              </td>
              
             <td class="td-button pr-2">
              <div class="dropdown is-right" :id="`dropdown-${item.id}`" @click.stop="(event) => showDropdownOptions(event, item.id , '#table-cards')">
                  <div class="dropdown-trigger">
                    <button class="button" aria-haspopup="true" aria-controls="dropdown-menu6" 
                      :disabled="!item.arquivo">
                      <span>Mais ações</span>
                      <span class="icon is-small">
                        <i class="mdi mdi-menu-down mdi-24px" aria-hidden="true"></i>
                      </span>
                    </button>
                  </div>
                  <div class="dropdown-menu" role="menu">
                    <div class="dropdown-content is-pulled-right">
                      <button class="dropdown-item button is-small" type="button" @click="(event) => downloadDocumentoModalRecebidosTotalizador(event, item)">
                        <i class="mdi mdi-download mdi-18px" aria-hidden="true"></i>
                        Download
                      </button>  
                    </div>
                  </div>
                </div>
             </td>
            </template>
          </TrfSimpleTable>
          <div v-if="TrfMixInfiniteScroll.listagemCarregando && !TrfMixInfiniteScroll.paginacaoFinalizada">
            <span class="button is-large is-fullwidth is-loading trf-is-borderless"></span>
          </div>
        </div>
      </TrfSimpleModal>
      
      <TrfSimpleModal titulo="Documentos" :isAtivo="isModalRecebidosListagemEmpresaAtivo" @close="fecharModalDocumentos" :isModalPersonalizado="true">
        <div id="conteudo-modal-cliente-documento" class="modal-list-content pt-0" @scroll="TrfMixAderirAoInfiniteScroll" style="max-height:60vh; max-width:1024px; width:100%;">   
         
          <TrfGlobalLoader type="overlay" v-if="isModalDocumentosRecebidosListagemEmpresaLoading" />

          <TrfSimpleTable 
            :configuracaoDeColunas="listagemConfiguracaoIndividualTarefasClienteConcluidas" 
            :dados="listagemDocumentosRecebidosListagemEmpresaTratados" 
            mensagemSemDados="Não há documentos para este filtro." 
            class="trf-simple-table"
            id="table-detalhes-documentos"
            >
            
            <template #th>
                <th></th>
                <th></th>
            </template>

            <template #td="{ item }" >
              <td class="td-button pl-2">
                <a class="button" aria-haspopup="true" target="_blank" :href="`//${urlFrontEcontador}Documentos/Visualizar/${item.id}`">
                  <span class="icon is-small">
                    <i class="mdi mdi-eye" aria-hidden="true"></i>
                  </span>
                  <span>Visualizar</span>
                </a>
              </td>
  
             <td class="td-button pr-2">
              <div class="dropdown is-right" :id="`dropdown-${item.id}`" @click.stop="(event) => showDropdownOptions(event, item.id, '#table-detalhes-documentos')">
                  <div class="dropdown-trigger">
                    <button class="button" aria-haspopup="true" aria-controls="dropdown-menu6">
                      <span>Mais ações</span>
                      <span class="icon is-small">
                        <i class="mdi mdi-menu-down mdi-24px" aria-hidden="true"></i>
                      </span>
                    </button>
                  </div>
                  <div class="dropdown-menu" role="menu">
                    <div class="dropdown-content is-pulled-right">
                      <button class="dropdown-item button is-small" type="button" @click="(event) => downloadDocumentoModalRecebidosListagemEmpresa(event, item)">
                        <i class="mdi mdi-download mdi-18px" aria-hidden="true"></i>
                        Download
                      </button>
                    </div>
                  </div>
                </div>
             </td>
            </template>
          </TrfSimpleTable>
          <div v-if="TrfMixInfiniteScroll.listagemCarregando && !TrfMixInfiniteScroll.paginacaoFinalizada">
            <span class="button is-large is-fullwidth is-loading trf-is-borderless"></span>
          </div>
        </div>
      </TrfSimpleModal>

      <div>
        <div class="mb-6 columns is-align-items-flex-start is-justify-content-space-between">
          <div class="column is-12-mobile">
            <div class="columns is-align-items-flex-start is-3">
              <div class="column is-5 is-12-mobile">
                <label>Empresa
                  <span
                  class="button is-loading is-white pl-2 pr-2 is-inline-block"
                  style="height: 1.25em"
                  v-if="isEmpresasLoading"
                ></span>
                </label>
                <Multiselect
                  :disabled="isEmpresasLoading"
                  :searchable="true"
                  :options="listaEmpresas"
                  v-model="empresaId"
                  class="multiselect-econtador is-fullwidth"
                  placeholder="Selecione"
                  noResultsText="Empresa não encontrada"
                  id="select-empresa-dashboard-cliente-filtrar"
                />
              </div>

              <div class="column is-4 is-12-mobile">
                <label>Departamento
                  <span
                    class="button is-loading is-white pl-2 pr-2 is-inline-block"
                    style="height: 1.25em"
                    v-if="isDepartamentosLoading"
                  ></span
                ></label>
                <Multiselect
                  :disabled="isDepartamentosLoading"
                  :searchable="true"
                  :options="listaDepartamentos"
                  v-model="departamentoId"
                  class="multiselect-econtador is-fullwidth"
                  placeholder="Selecione"
                  noResultsText="Departamento não encontrado"
                  id="select-departamento-dashboard-cliente-filtrar"
                />
              </div>

              <div class="column is-3 is-12-mobile">
                <label>Status
                  <span
                    class="button is-loading is-white pl-2 pr-2 is-inline-block"
                    style="height: 1.25em"
                    v-if="isStatusLoading"
                  ></span
                ></label>
                <Multiselect
                  :disabled="isStatusLoading"
                  :searchable="true"
                  :options="listaStatus"
                  v-model="statusId"
                  class="multiselect-econtador is-fullwidth"
                  placeholder="Selecione"
                  noResultsText="Tarefa não encontrada"
                  id="select-nome-tarefa-dashboard-cliente-filtrar"
                />
              </div>

              <div class="column is-4 is-12-mobile">
                <label>Nome da tarefa
                  <span
                    class="button is-loading is-white pl-2 pr-2 is-inline-block"
                    style="height: 1.25em"
                    v-if="isTarefasDoClienteLoading"
                  ></span
                ></label>
                <Multiselect
                  :disabled="isTarefasDoClienteLoading"
                  :searchable="true"
                  :options="listaTarefasDoCliente"
                  v-model="nomeTarefa"
                  class="multiselect-econtador is-fullwidth"
                  placeholder="Selecione"
                  noResultsText="Tarefa não encontrada"
                  id="select-nome-tarefa-dashboard-cliente-filtrar"
                />
              </div>
            </div>
          </div>
  
          <div class="column is-3"></div>
  
          <div class="column is-narrow-desktop is-12-mobile">
            <label class="is-invisible">Filtrar</label>
            <TrfButton
              id="btn-filtrar-historico"
              nome="Filtrar"
              class="is-fullwidth is-primary"
              :class="{ 'is-loading': isTotalizadoresLoading }"
              @click="this.filtrar()"
            />
          </div>
        </div>

          <div class="columns is-justify-content-center is-2 is-multiline">
            <TrfDashboardTotalizadoresCards :totalizadores="listagemTotalizadores"/>
          </div>

          <p class="empresa-listagem-vazia is-size-3" v-if="!primeiroCarregamento && indicativosEmpresas.length == 0">Não há informações</p>
          <DashboardEmpresaListagem v-if="!!indicativosEmpresas && indicativosEmpresas.length > 0" :dados="indicativosEmpresas" :periodo="this.adquirirIntervaloAno()" @trf-empresa-icon-click="acionarRotinaDeAcordoComIconeClicado" :isLoading="isModalDocumentosRecebidosListagemEmpresaLoading" :opcoesDropdown="opcoesDropdownListagem"/>
          <div v-if="primeiroCarregamento || (TrfMixInfiniteScrollCustomConfig.indicativosEmpresa.listagemCarregando && !TrfMixInfiniteScrollCustomConfig.indicativosEmpresa.paginacaoFinalizada)">
            <span class="button is-large is-fullwidth is-loading trf-is-borderless"></span>
          </div>
    </div>
    <TrfVoltarAoTopo/>

    <TrfModal
      v-if="isModalConclusaoActive"
      idModal="trf-modal-concluir-selecionado"
      titulo="Concluir tarefa"
      btnSaveName="Confirmar"
      :isBtnLoading="isModalConclusaoLoading"
      @save="async (event) => await concluirTarefa(event)"
      @close="fecharModalConclusao"
    >
      <p>Deseja realmente concluir esta <strong>tarefa</strong>?<br /><br /></p>
    </TrfModal>
</template>

<script>
import TrfSimpleModal from "../../components/Modal/TrfSimpleModal.vue";
import TrfGlobalLoader from "../../components/GlobalLoader";
import TrfSimpleTable from "../../components/SimpleTable";
import TrfDashboardTotalizadoresCards from "../DashboardGestor/components/DashboardTotalizadoresCards";
import Multiselect from "@vueform/multiselect";
import TrfButton from "../../components/Button";
import { TrfMixinInfiniteScroll } from '../../mixins/infinitescroll';
import { service } from "../DashboardCliente/service/status-service";
import { empresasService } from "../../service/empresas-service";
import { documentoService } from "../../service/documento-service";
import { service as tarefasService } from "../CadastroTarefas/service/cadastro-tarefas-service";
import { service as historicoService } from "../../views/Dashboard/service/historico-tarefas-service";
import { totalizadoresPorTipoService } from "../../service/totalizadores-por-tipo-service";
import { service as totalizadorService } from "./service/totalizador-service";
import { env } from "../../env";
import { utils } from "../../util/utils";
import { departamentoUtils } from "../../util/departamento.utils";
import { toastUtils } from '../../util/toast.utils';
import DashboardEmpresaListagem from './components/DashboardEmpresaListagem';
import { totalizadorClienteService } from './service/totalizador-cliente-service';
import TrfVoltarAoTopo from '../../components/VoltarAoTopo';
import TrfModal from "../../components/Modal";

const TAREFAS_ESPECIAIS = {
  RECALCULO_GUIA_PARCELAMENTO: "Recálculo da guia de parcelamento"
};

export default {
  name: "DashboardCliente",
  components: {
    Multiselect,
    TrfButton,
    TrfDashboardTotalizadoresCards,
    TrfSimpleModal,
    TrfGlobalLoader,
    TrfSimpleTable,
    DashboardEmpresaListagem,
    TrfVoltarAoTopo,
    TrfModal
  },
  mixins: [TrfMixinInfiniteScroll],
  data() {
    return {
      listaDadosParaDownload:[],
      listaDepartamentos: [],
      isDepartamentosLoading: true,
      departamentoId: null,
      listaEmpresas: [],
      isEmpresasLoading: true,
      empresaId: null,
      isTarefasDoClienteLoading: true,
      listaTarefasDoCliente: [],
      nomeTarefa: null,
      modalListagemTitulo: '',
      modalListagemFiltroStatus: '',
      modalListagemAtivo: false,
      listagemDadosDocumentos: [],
      urlFrontEcontador: env.econtadorFront,
      isDocumentDownloading: false,
      isStatusLoading: true,
      listaStatus: [],
      statusId: null,
      listagemDados: [],
      isModalRecebidosListagemEmpresaAtivo: false,
      listaDocumentosRecebidosListagemEmpresa: [],
      totalizadores: {},
      indicativosEmpresas: [],
      primeiroCarregamento: true,
      statusSelecionado: "",
      isModalDocumentosRecebidosListagemEmpresaLoading: false,
      recorrenciaSelecionada: [],
      isModalConclusaoActive: false,
      isModalConclusaoLoading: false,
      filtrosAplicados: {},
      idEmpresa: null
    };
  },

  methods: {
    async iniciarModalRecebidosListagemEmpresa(documentoId) {
      try {
        const queryString = "filter[id]="+ documentoId + "&";
        this.listaDocumentosRecebidosListagemEmpresa = await documentoService.getDocumentos(queryString);
        this.isModalRecebidosListagemEmpresaAtivo = true;
      } catch (e) {
        console.error(e);
      } finally {
        this.isModalDocumentosRecebidosListagemEmpresaLoading = false;
      }
    },
    fecharModalDocumentos() {
      this.isModalRecebidosListagemEmpresaAtivo = false;
    },
    acionarRotinaDeAcordoComIconeClicado(recorrencia, idEmpresa) {
      if(recorrencia.status.id == this.statusEnum.CONCLUIDO && !recorrencia.acaoStatus) {
        this.isModalDocumentosRecebidosListagemEmpresaLoading = true;
        this.iniciarModalRecebidosListagemEmpresa(recorrencia.documentoId)
      } else {
        this.recorrenciaSelecionada = recorrencia;
        this.idEmpresa = idEmpresa;
      }
    },
    async filtrar() {
      await Promise.all([this.carregarTotalizador(), this._carregarListagemIndicadoresEmpresas(true)])
    },
    async carregarTotalizador() {
      this.filtrosAplicados = {
        filtrosRequisicaoIndicadores: this.filtrosRequisicaoIndicadores,
        filtrosRequisicaoHistorico: this.filtrosRequisicaoHistorico
      }
      this.statusSelecionado = this.statusId;
      this.isTotalizadoresLoading = true;
      try {
        let dataInicial = this.adquirirIntervaloAno().dataInicial;
        let dataFinal = this.adquirirIntervaloAno().dataFinal;

        let objetoQueryString = {
          dataInicial,
          dataFinal,
          tarefaCliente: true
        }
        objetoQueryString = this.adicionarDepartamentoQueryString(objetoQueryString);
        objetoQueryString = this.adicionarEmpresaQueryString(objetoQueryString);
        objetoQueryString = this.adicionarTarefaQueryString(objetoQueryString);
        objetoQueryString = this.adicionarStatusQueryString(objetoQueryString);
        const totalizadores = await totalizadorService.get(objetoQueryString);
        this.totalizadores = totalizadores.data[0];
      } catch(e) {
        toastUtils.dangerToast("Ocorreu um erro ao carregar o dashboard! Tente novamente mais tarde.");
      } finally {
        this.isTotalizadoresLoading = false;
      }
    },

    async atualizarFiltros() {
      this.filtrosAplicados = {
        filtrosRequisicaoIndicadores: this.filtrosRequisicaoIndicadores,
        filtrosRequisicaoHistorico: this.filtrosRequisicaoHistorico
      }
    },

    adicionarDepartamentoQueryString(objetoQueryString) {
      if(!this.departamentoId) return objetoQueryString;

      if (this.departamentoId.includes("P")) {
        objetoQueryString.departamentoPadrao = this.departamentoId.replace("P", "");
      } else {
        objetoQueryString.departamento = this.departamentoId;
      }

      return objetoQueryString;
    },
    adicionarEmpresaQueryString(objetoQueryString) {
      if(!this.empresaId) return objetoQueryString;
      objetoQueryString.empresa  = this.empresaId;
      return objetoQueryString;
    },
    adicionarTarefaQueryString(objetoQueryString) {
      if(!this.nomeTarefa) return objetoQueryString;

      if (this.nomeTarefa === TAREFAS_ESPECIAIS.RECALCULO_GUIA_PARCELAMENTO) {
          objetoQueryString = {
            ...objetoQueryString,
            "nome[ILIKE]": `${this.nomeTarefa}%`,
          };

          return objetoQueryString;
        }
        
        objetoQueryString.nome = this.nomeTarefa.replace(/\s/g, "%20");

        return objetoQueryString;
    },
    adicionarStatusQueryString(objetoQueryString) {
      if(!this.statusId) return objetoQueryString;
      objetoQueryString.status  = this.statusId;
      return objetoQueryString;
    },
    async iniciarModal(tipo) {
      if(!!this.desabilitaInteracaoComCartao) return;
      this.desabilitaInteracaoComCartao = true;
      switch (tipo) {
        case 'pendente':
          this.modalListagemTitulo = "Tarefas aguardando cliente";
          this.modalListagemFiltroStatus = this.statusEnum.PENDENTE;
          break;
        case 'atrasada':
          this.modalListagemTitulo = "Tarefas com status atrasada";
          this.modalListagemFiltroStatus = this.statusEnum.ATRASADA;
          break;
        case 'concluido':
          this.modalListagemTitulo = "Tarefas com status concluído";
          this.modalListagemFiltroStatus = this.statusEnum.CONCLUIDO;
          break;
      }

      this.filtrosAplicados.filtrosRequisicaoHistorico.status = this.modalListagemFiltroStatus;

      this.mostraLoaderDoCartaoPorTipo(tipo);
      const listagem = await this._carregarListagemModal(true);
      if(this.listagemDados.length > 0) {
        this.modalListagemAtivo = true;
      } else {
        toastUtils.infoToast("Não há tarefas a serem exibidas.")
      }
      this.escondeLoaderDoCartaoPorTipo(tipo);
      this.desabilitaInteracaoComCartao = false;
    },
    mostraLoaderDoCartaoPorTipo(tipo) {
      const loader = document.getElementById(`loading-card-${tipo}`);
      if(!!loader && loader.classList.contains('is-hidden')) {
        loader.classList.remove('is-hidden');
      }
    },
    escondeLoaderDoCartaoPorTipo(tipo) {
      const loader = document.getElementById(`loading-card-${tipo}`);
      if(!!loader && !!!loader.classList.contains('is-hidden')) {
        loader.classList.add('is-hidden');
      }
    },
    fecharModal() {
      this.modalListagemAtivo = false;

      const conteudoComScroll = document.getElementById('conteudo-modal-cliente-listagem');
      if(!!conteudoComScroll) {
        conteudoComScroll.scrollTo(0, 0);
      }
      this.$refs.tableCardsModal.limparCheckedBox();
      this.listaDadosParaDownload.length = 0;
    },
    async _carregarListagemModal(resetar) {
      try {
        if (!!resetar) {
          this.resetarPaginacao();
        }

        this.atualizarFiltros();

        const listaDeHistoricos = await historicoService.listarHistorico(this.filtrosAplicados.filtrosRequisicaoHistorico);
        
        this.listagemDados = [...this.listagemDados, ...listaDeHistoricos.data];

        if(this.modalListagemFiltroStatus == this.statusEnum.CONCLUIDO) {
          let queryString = this.montarQueryStringDocumentosIds();
          this.listagemDadosDocumentos = await documentoService.getDocumentos(queryString);
        }

        const total = parseInt(listaDeHistoricos.totalDeItens);
        this.TrfMixInfiniteScroll.paginacaoFinalizada = total == this.listagemDados.length;
      } catch (e) {
        console.error(e);
      }
    },
    async _carregarListagemIndicadoresEmpresas(resetar) {
      try {
        if (!!resetar) {
          this.primeiroCarregamento = true;
          this.indicadoresResetarPaginacao();
        }

        const listaDeIndicadores = await totalizadorClienteService.get(this.filtrosRequisicaoIndicadores);
        
        this.indicativosEmpresas = [...this.indicativosEmpresas, ...listaDeIndicadores.data];

        const total = parseInt(listaDeIndicadores.totalDeItens);
        this.TrfMixInfiniteScrollCustomConfig.indicativosEmpresa.paginacaoFinalizada = total == this.indicativosEmpresas.length;
        this.primeiroCarregamento = false;
      } catch (e) {
        console.error(e);
        this.primeiroCarregamento = false;
      }
    },
    montarQueryStringDocumentosIds() {
      let queryString = ""; 
      this.listagemDados.map((item) => {
        queryString += "filter[id]="+ item.documentoId + "&";
      })
      return queryString;
    },
    indicadoresResetarPaginacao() {
      this.TrfMixInfiniteScrollCustomConfig.indicativosEmpresa.page = 1;
      this.TrfMixInfiniteScrollCustomConfig.indicativosEmpresa.limit = 100;
      this.TrfMixInfiniteScrollCustomConfig.indicativosEmpresa.paginacaoFinalizada = false;
      this.indicativosEmpresas = [];
    },
    async indicadoresIncrementarPagina(page, limit) {
      this.TrfMixInfiniteScrollCustomConfig.indicativosEmpresa.page = page+1;
      this.TrfMixInfiniteScrollCustomConfig.indicativosEmpresa.limit = limit;
      const request = await this._carregarListagemIndicadoresEmpresas(false);
    },
    resetarPaginacao() {
      this.TrfMixInfiniteScroll.page = 1;
      this.TrfMixInfiniteScroll.limit = 100;
      this.TrfMixInfiniteScroll.paginacaoFinalizada = false;
      this.listagemDados = [];
    },
    async TrfMixIncrementarPagina(page, limit) {
      this.TrfMixInfiniteScroll.page = page+1;
      this.TrfMixInfiniteScroll.limit = limit;
      const request = await this._carregarListagemModal(false);
    },
    adquirirIntervaloAno() {
      const hoje = new Date() ;
      const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
      const primeiroDia = new Date(hoje.getFullYear() -1, hoje.getMonth() + 1, 1);

      return {
        dataInicial: utils.formatarCampoDataParaEnvioAoBackendSemHora(primeiroDia),
        dataFinal: utils.formatarCampoDataParaEnvioAoBackendSemHora(ultimoDia)
      };
    },

    async adquirirStatus() {
      this.isStatusLoading = true;
      const statusData = await service.getStatus();
      this.listaStatus = statusData.map((status) => {
        return  {
          value: status.id,
          label: this.renomearStatus(status.nome)
        }
      })
      this.isStatusLoading = false;
      return this.listaStatus;
    },
    renomearStatus(status) {
      switch (status) {
        case "A fazer":
          return "Aguardando cliente";
        case "Concluído":
          return "Recebidos";
        case "Atrasada":
          return "Atrasada"; 
      }
    },
    async adquirirEmpresas() {
      this.isEmpresasLoading = true;
      this.listaEmpresas = await empresasService.listarEmpresas();
      this.isEmpresasLoading = false;
      return this.listaEmpresas;
    },
    async adquirirDepartamentos() {
      this.isDepartamentosLoading = true;
      this.listaDepartamentos = await departamentoUtils.adquirirTodosOsDepartamentos();
      this.isDepartamentosLoading = false;
      return this.listaDepartamentos;
    },
    async adquirirTarefasDoCliente() {
      this.isTarefasDoClienteLoading = true;
      const tarefasData = await this._adquirirTodasAsTarefasDoCliente();
      this.listaTarefasDoCliente = this._converterTarefasDoCienteParaObjetoDoSelect(tarefasData);
      this.isTarefasDoClienteLoading = false;
      return this.tarefas;
    },
    async _adquirirTodasAsTarefasDoCliente() {
      let limit = await totalizadoresPorTipoService.listarNomes(
        this.filtroRequisicaoTarefasDoCliente
      );
      const requestCustomizado = {
        ...this.filtroRequisicaoTarefasDoCliente,
        limit: limit.totalDeItens
      }
      const tarefas = await totalizadoresPorTipoService.listarNomes(
        requestCustomizado
      );
      return tarefas.data;
    },
    _converterTarefasDoCienteParaObjetoDoSelect(tarefas) {
      if(!!!tarefas) return {};

      const objetoDoSelect = tarefas.map((tarefa) => {
        const option = {
          value: typeof tarefa === 'string' ? tarefa : tarefa.nome,
          label: typeof tarefa === 'string' ? tarefa : tarefa.nome
        };
        return option;
      });
      return objetoDoSelect;
    },
    showDropdownOptions(event, item, tableId) {
      const table = document.querySelector(tableId);
      let botaoDoUltimoItemDaLista = this.getBotaoDropdownDoUltimoItemDaListaCardSemPendencias(table);
      const dropdown = document.querySelector(`${tableId} #dropdown-${item}`);

      if(botaoDoUltimoItemDaLista.id == dropdown.id) {
        table.classList.toggle("pb-5");
      }

      const dropdownActive = dropdown.classList.contains("is-active");
      this.closeDropdownsOptions();

      if (dropdownActive) return;

      dropdown.classList.toggle("is-active");
    },
    getBotaoDropdownDoUltimoItemDaListaCardSemPendencias(table) {
      let tbody = table.querySelector("tbody");
      let ultimoItemDaTabela = tbody.lastElementChild;
      let botaoDoUltimoItemDaLista = ultimoItemDaTabela.querySelector(".dropdown.is-right");

      return botaoDoUltimoItemDaLista;
    },
    closeDropdownsOptions(event) {
      if (event) event.stopPropagation();
      const dropdownsActive = document.querySelectorAll("table .is-active");
      for (let dropdown of dropdownsActive) {
        dropdown.classList.remove("is-active");
      }
    },
    onClickDocument(event) {
      const dropdownActive = document.querySelector("table .is-active");
      if (dropdownActive == null) return;
      const isClickInsideElement = dropdownActive.contains(event.target);
      if (isClickInsideElement) return;
      this.closeDropdownsOptions();
    },
    async downloadDocumentoModalRecebidosTotalizador(event, lista) {
      lista = JSON.parse(JSON.stringify(lista))
      try {
        if (Array.isArray(lista)) {
          if (lista.length > 1) {
            this.isDocumentDownloading = true;
            const listaArquivos = await this.downloadDocumentos(lista);
          } else if (lista.length > 0) {
            this.isDocumentDownloading = true;
            const arquivo = await this.downloadDocumento(lista);
          }
        } else {
          this.isDocumentDownloading = true;
          const arquivo = await this.downloadDocumento(lista);
        }
      } catch (e) {
        console.error(e);
      }
      this.isDocumentDownloading = false;
    },
    async downloadDocumentoModalRecebidosListagemEmpresa(event, item) {
      try {
        this.isModalDocumentosRecebidosListagemEmpresaLoading = true;
        const arquivo = await this.downloadDocumento(item);
      } catch (e) {
        console.error(e);
      }
      this.isModalDocumentosRecebidosListagemEmpresaLoading = false;
    },
    async downloadDocumento(item) {
      let doc = item;
      if(Array.isArray(item)) {
        doc = this.listagemDadosTratadosTarefasClienteConcluidas.find(d => d.id == item[0].id);
      }
      const arquivo = await documentoService.downloadById(doc.arquivo.id, 'application/octet-stream', doc.arquivo.filename) ;
    },
    async downloadDocumentos(item) {
      const arquivo = await documentoService.downloadLista(item, 'application/zip')
    },
    obterDadosDoArquivo(listagemDocumentos, dadosDoDocumento) {
      let arquivo = {};
      dadosDoDocumento.relationships.arquivos.data.map(arq => {
        const dadosArquivo = listagemDocumentos.included.find(
          detail =>
            detail.id === arq.id &&
            detail.type === arq.type
        );
        arquivo = {
          id: arq.id,
          attributes: dadosArquivo.attributes,
          filename: `${dadosArquivo.attributes.nome}${dadosArquivo.attributes.extensao}`,
          download: dadosArquivo.links.self
        };
      })
      return arquivo;
    },
    obterNomeCategoria(dadosDoDocumento) {
      const dadosCategoria = this.listaDocumentosRecebidosListagemEmpresa.included.find(
        detail =>
          detail.id === dadosDoDocumento.relationships.categoria.data.id &&
          detail.type === dadosDoDocumento.relationships.categoria.data.type
      );
      const nomeCategoria = dadosCategoria.attributes.descricao;
      return nomeCategoria;
    },
    renomearChave(objeto, chaveAntiga, chaveNova) {
      if(!!!objeto) return {};
      if(!!!chaveAntiga || !!!chaveNova || chaveAntiga == chaveNova || !!!objeto[chaveAntiga]) return objeto;
      Object.defineProperty(objeto, chaveNova, Object.getOwnPropertyDescriptor(objeto, chaveAntiga));
      delete objeto[chaveAntiga];
      return objeto;
    },
    aderirAoScrollCustomizado(event) {
      this.TrfMixAderirAoInfiniteScroll(event, 'indicativosEmpresa');
      this.TrfMixAderirAoInfiniteScroll(event, 'listagemDados');
    },
    iniciarEventoDeScroll() {
      document.addEventListener('scroll', this.aderirAoScrollCustomizado);
    },

    removerEventoDeScroll() {
      document.removeEventListener('scroll', this.aderirAoScrollCustomizado)
    },
    abortarRequestsEmAndamento() {
      service.abortarTodosOsUltimosRequests();
      empresasService.abortarTodosOsUltimosRequests();
      documentoService.abortarTodosOsUltimosRequests();
      tarefasService.abortarTodosOsUltimosRequests();
      historicoService.abortarTodosOsUltimosRequests();
      totalizadorService.abortarTodosOsUltimosRequests();
      totalizadorClienteService.abortarTodosOsUltimosRequests();
    },
    preencheArrayDocumentos(ids) {
      this.listaDadosParaDownload = ids.map(id => { return { id } });
    },

    iniciarModalConclusao() {
      this.isModalConclusaoActive = true;
    },

    async concluirTarefa() {
      this.isModalConclusaoLoading = true;
      let todasRecorrenciasConcluidas = true;
      let existemTarefasAtrasadas = false;
      
      const recorrenciaASerConcluida = this.recorrenciaSelecionada.historicoTarefaId;
      const sucess = await historicoService.concluirManualmenteDashboardDoCliente(recorrenciaASerConcluida);

      if (sucess) {
          let departamentos = this.indicativosEmpresas.find(empresa => empresa.empresaId == this.idEmpresa).departamentos;

          for (let j = 0; j < departamentos.length; j++) {
              let tarefas = departamentos[j].tarefas;

              for (let k = 0; k < tarefas.length; k++) {
                  let recorrencias = tarefas[k].recorrencias;

                  for (let l = 0; l < recorrencias.length; l++) {
                      if (recorrencias[l].historicoTarefaId === this.recorrenciaSelecionada.historicoTarefaId) {
                          recorrencias[l].status.id = this.statusEnum.CONCLUIDO;
                          recorrencias[l].acaoStatus = this.acaoStatusEnum.CONCLUSAO_MANUAL;

                          if(!!this.filtrosAplicados.filtrosRequisicaoIndicadores.status) {
                            recorrencias.splice(l, 1);
                            l--;
                          }
                      }
                      
                      let existemRecorrenciasAConcluir =  recorrencias.filter(recorrencia => recorrencia.status?.id != this.statusEnum.CONCLUIDO);                 

                      if(!!this.filtrosAplicados.filtrosRequisicaoIndicadores.status && existemRecorrenciasAConcluir.length == 0) {
                        tarefas.splice(k, 1);
                        k--;
                      }
                  }
              }
          }
          
          for (let j = 0; j < departamentos.length; j++) {
            const tarefas = departamentos[j].tarefas;
            let todasTarefasDoDepartamentoConcluidas = true;

            for (let k = 0; k < tarefas.length; k++) {
              const recorrencias = tarefas[k].recorrencias;

              for (let l = 0; l < recorrencias.length; l++) { 
                if (recorrencias[l].status.id != this.statusEnum.CONCLUIDO) {
                  todasRecorrenciasConcluidas = false;
                  todasTarefasDoDepartamentoConcluidas = false;
                  break;
                }
              }
              
              if (!todasRecorrenciasConcluidas) break;
            }

            if (todasTarefasDoDepartamentoConcluidas && !!this.filtrosAplicados.filtrosRequisicaoIndicadores.status) {
              departamentos.splice(j, 1);
              j--;
            }

            if (!todasRecorrenciasConcluidas) break;
          }


          for (let j = 0; j < departamentos.length; j++) {
            const tarefas = departamentos[j].tarefas;

            for (let k = 0; k < tarefas.length; k++) {
              const recorrencias = tarefas[k].recorrencias;

              for (let l = 0; l < recorrencias.length; l++) {
                if (recorrencias[l].status.id == this.statusEnum.ATRASADA) {
                  existemTarefasAtrasadas = true;
                  break;
                }
              }
              
              if (existemTarefasAtrasadas) break;
            }

            if (existemTarefasAtrasadas) break;
          }    
          
          this.alterarStatusDoIndicativo(todasRecorrenciasConcluidas, existemTarefasAtrasadas);
          await Promise.all([this.carregarTotalizador()]);
          this.isModalConclusaoLoading = false;
          this.fecharModalConclusao();
      }
    },

    alterarStatusDoIndicativo(todasRecorrenciasConcluidas, existemTarefasComAtraso) {
      if (!todasRecorrenciasConcluidas && existemTarefasComAtraso) return;

      if(!!this.filtrosAplicados.filtrosRequisicaoIndicadores.status && todasRecorrenciasConcluidas) {
        this.indicativosEmpresas = this.indicativosEmpresas.filter(empresa => empresa.empresaId != this.idEmpresa);
        return;
      }

      const indicativo = this.indicativosEmpresas.find(empresa => empresa.empresaId == this.idEmpresa);

      if (indicativo?.status && !todasRecorrenciasConcluidas && !existemTarefasComAtraso) {
        indicativo.status.id = this.statusEnum.PENDENTE;
        return;
      }

      if (indicativo?.status && todasRecorrenciasConcluidas) {
        indicativo.status.id = this.statusEnum.CONCLUIDO;
      }
    },

    fecharModalConclusao() {
      this.isModalConclusaoActive = false;
    },

    tarefaDoDocumentoEnviadoTratada(tarefaDoDocumentoEnviado, dadosDocumento){
      let dadoTratado = {};    
      tarefaDoDocumentoEnviado.map((tarefa) => {
        dadoTratado = {
          id: dadosDocumento.id,
          nome: dadosDocumento.attributes.titulo,
          dataDeEnvio: utils.formatarDataParaExibicaoNoDataTable(dadosDocumento.attributes.criacao),
          empresa: `${tarefa.empresa.externoId} - ${tarefa.empresa.nome}`,
          departamento: !!tarefa.departamentoPadrao && !!!tarefa.departamento? tarefa.departamentoPadrao.nome : tarefa.departamento.nome,
          arquivo: this.obterDadosDoArquivo(this.listagemDadosDocumentos, dadosDocumento),
          tarefaId: tarefa.id,
          showCheckboxDownload: true
        };
      }) 

      return dadoTratado;
    },

    tarefaConcluidaManualmenteTratada(tarefa) {
      const dadoTratado = {
        id: tarefa.id,
        nome: tarefa.nome,
        dataDeEnvio: utils.formatarDataParaExibicaoNoDataTable(tarefa.dataConclusao),
        empresa: `${tarefa.empresa.externoId} - ${tarefa.empresa.nome}`,
        departamento: !!tarefa.departamentoPadrao && !!!tarefa.departamento? tarefa.departamentoPadrao.nome : tarefa.departamento.nome,
        showCheckboxDownload: false
      };
 
      return dadoTratado;
    },

    getTarefasConcluidasManualmente(listagemTratada) {
      const tarefasConcluidasManualmente = this.listagemDados.filter(detail=>
        !listagemTratada.map(dadoTratado => dadoTratado.tarefaId).includes(detail.id)
      ); 

      return tarefasConcluidasManualmente;
    }
  },
  computed: {
    opcoesDropdownListagem(){
      const opcoes = [{
        nome: "Concluir",
        icon: "mdi-check",
        id:"dropdown-listagem-empresa",
        acao: () => this.iniciarModalConclusao()
      }]
      return opcoes;
    },
    filtrosRequisicaoHistorico() {
      let objetoDeFiltro = {
        "sort[ASC]": "prazoEntrega,id",
        "dataInicial":  this.adquirirIntervaloAno().dataInicial,
        "dataFinal": this.adquirirIntervaloAno().dataFinal,
        "prazoEntrega[GT]": this.adquirirIntervaloAno().dataInicial,
        "tarefaCliente": true,
        status: this.modalListagemFiltroStatus || "",
        pagina: this.TrfMixInfiniteScroll.page || 1,
        limit: this.TrfMixInfiniteScroll.limit || 100,
      };
      objetoDeFiltro = this.adicionarDepartamentoQueryString(objetoDeFiltro);
      objetoDeFiltro = this.renomearChave(objetoDeFiltro, "departamentoId", "departamento");
      objetoDeFiltro = this.adicionarEmpresaQueryString(objetoDeFiltro);
      objetoDeFiltro = this.renomearChave(objetoDeFiltro, "empresa", "empresaId");
      objetoDeFiltro = this.adicionarTarefaQueryString(objetoDeFiltro);
      return objetoDeFiltro;
    },
    filtrosRequisicaoIndicadores() {
      let objetoDeFiltro = {
        "dataInicial":  this.adquirirIntervaloAno().dataInicial,
        "dataFinal": this.adquirirIntervaloAno().dataFinal,
        "tarefaCliente" : true,
        status: this.statusId || "",
        pagina: this.TrfMixInfiniteScrollCustomConfig.indicativosEmpresa.page || 1,
        limit: this.TrfMixInfiniteScrollCustomConfig.indicativosEmpresa.limit || 10
      };
      objetoDeFiltro = this.adicionarDepartamentoQueryString(objetoDeFiltro);
      objetoDeFiltro = this.renomearChave(objetoDeFiltro, "departamentoId", "departamento");
      objetoDeFiltro = this.adicionarEmpresaQueryString(objetoDeFiltro);
      objetoDeFiltro = this.adicionarTarefaQueryString(objetoDeFiltro);
      return objetoDeFiltro
    },
    filtroRequisicaoTarefasDoCliente() {
      const objetoDeFiltro = {
        limit: 1,
        pagina: 1,
        "tarefaCliente": true
      }
      return objetoDeFiltro;
    },
    listagemDocumentosRecebidosListagemEmpresaTratados() {
      if(this.listaDocumentosRecebidosListagemEmpresa.length == 0) return [];

      const listagemTratada = this.listaDocumentosRecebidosListagemEmpresa.data.map(dado => {
        const dadoTratado = {
          id: dado.id,
          nome: dado.attributes.titulo,
          dataDeEnvio: utils.formatarDataParaExibicaoNoDataTable(dado.attributes.criacao), 
          categoria: this.obterNomeCategoria(dado),
          arquivo: this.obterDadosDoArquivo(this.listaDocumentosRecebidosListagemEmpresa, dado),
        }

        return dadoTratado;
      })

      return listagemTratada;
    },
    listagemDadosTratadosTarefasClienteConcluidas() {
      if(this.listagemDadosDocumentos.length == 0) return [];
      const listagemTratada = [];
      this.listagemDadosDocumentos.data.map(dadosDocumento => {
        const tarefaDoDocumentoEnviado = this.listagemDados.filter(detail=>
           detail.documentoId == dadosDocumento.id && detail.baixaPersonalizada == dadosDocumento.nome
        )

        if(tarefaDoDocumentoEnviado.length > 0 ) {
          const tarefaDoDocumentoEnviadoTratada = this.tarefaDoDocumentoEnviadoTratada(tarefaDoDocumentoEnviado, dadosDocumento);
          listagemTratada.push(tarefaDoDocumentoEnviadoTratada);
        }
      });
      
      const tarefasConcluidasManualmente = this.getTarefasConcluidasManualmente(listagemTratada);

      if(tarefasConcluidasManualmente.length > 0){
        tarefasConcluidasManualmente.map((tarefa) => {
          const tarefaConcluidaManualmenteTratada = this.tarefaConcluidaManualmenteTratada(tarefa)
          listagemTratada.push(tarefaConcluidaManualmenteTratada);
        });
      }

      return listagemTratada;
    },  
    listagemDadosTratados() {
      if(!!!this.listagemDados) return [];

      const listagemTratada = this.listagemDados.map(dado => {
        const dadoTratado = {
          nome: dado.nome,
          empresa: `${dado.empresa.externoId} - ${dado.empresa.nome}`,
          prazoEntrega: utils.formatarDataParaExibicaoNoDataTable(dado.prazoEntrega),
          departamento: !!dado.departamentoPadrao && !!!dado.departamento? dado.departamentoPadrao.nome : dado.departamento.nome,
          responsavel: !!dado.responsavel && dado.responsavel.nome
        }

        return dadoTratado;
      })

      return listagemTratada;
    },
    listagemConfiguracaoIndividualTarefasClienteConcluidas() {
    return [
        {
          titulo: "Documento",
          referencia: ['nome'],
          divisor: "",
          customStyle: "width: 325px;"
        },
        {
          titulo: "Enviado em",
          referencia: ['dataDeEnvio'],
          divisor: ` - `,
          customStyle: "width:140px;"
        },
        {
          titulo: "Categoria",
          referencia: ['categoria'],
          divisor: "",
          customStyle: "width: 255px;"
        },
      ]
    },
    listagemConfiguracaoTarefasCliente() {
    return [
      {
          titulo: "Nome da tarefa",
          referencia: ['nome'],
          divisor: "",
          customStyle: "width: 325px;"
        },
        {
          titulo: "Data de entrega",
          referencia: ['prazoEntrega'],
          divisor: "",
          customStyle: "width: 140px;"
        },
        {
          titulo: "Nome da empresa",
          referencia: ['empresa'],
          divisor: ` - `,
          customStyle: "width:255px;"
        },
        {
          titulo: "Departamento",
          referencia: ['departamento'],
          divisor: "",
          customStyle: "width: 200px;"
        },
      ]
    },
    listagemConfiguracaoTarefasClienteConcluidas() {
    return [
        {
          titulo: "Documento",
          referencia: ['nome'],
          divisor: "",
          customStyle: "width: 325px;"
        },
        {
          titulo: "Enviado em",
          referencia: ['dataDeEnvio'],
          divisor: ` - `,
          customStyle: "width:140px;"
        },
        {
          titulo: "Empresa",
          referencia: ['empresa'],
          divisor: "",
          customStyle: "width: 255px;"
        },
        {
          titulo: "Departamento",
          referencia: ['departamento'],
          divisor: "",
          customStyle: "width: 200px;"
        }
      ]
    },
    statusEnum() {
      const status = {
        PENDENTE: "1",
        ATRASADA: "5",
        CONCLUIDO: "2",
      };
      return status;
    },
    acaoStatusEnum() {
      const acaoStatus = {
        CONCLUSAO_MANUAL: 1
      };
      return acaoStatus;
    },
    listagemTotalizadores() {
      return [
        {
          id: "card-pendente",
          tipo: "pendente", 
          nome: "Aguardando cliente",
          quantidade: this.totalizadores.aVencer,
          cor: "#5692E6",
          icone: "clock",
          isLoading: this.isTotalizadoresLoading,
          isCardSempreVisivel : this.statusSelecionado ==  "" || this.statusSelecionado == 1 || this.statusSelecionado == null ,
          acao: () => this.iniciarModal('pendente')
        },
        {
            id: "card-atrasa",
            tipo: "atrasada", 
            nome: "Atrasadas",
            quantidade: this.totalizadores.atrasadas,
            cor: "#E33B3C",
            icone: "triangle-exclamation",
            isLoading: this.isTotalizadoresLoading,
            isCardSempreVisivel : this.statusSelecionado ==  "" || this.statusSelecionado == 5 || this.statusSelecionado ==  null,
            acao: () => this.iniciarModal('atrasada')
        },
        {
            id: "card-concluido",
            tipo: "concluido", 
            nome:  "Recebidos",
            quantidade: this.totalizadores.concluidas,
            cor: "#32AA45",
            icone: "check",
            isLoading: this.isTotalizadoresLoading,
            isCardSempreVisivel : this.statusSelecionado ==  "" || this.statusSelecionado == 2 || this.statusSelecionado ==  null,
            acao: () => this.iniciarModal('concluido')
        }
      ]
    }
  },
  created() {
    this.TrfMixInfiniteScrollCustomConfig.indicativosEmpresa = {
      page: 1,
      limit: 10,
      paginacaoFinalizada: false,
      listagemCarregando: false,
      incrementFn: (page, limit) => this.indicadoresIncrementarPagina(page, limit)
    }
  },
  mounted() {
    this.carregarTotalizador();
    this.adquirirEmpresas();
    this.adquirirDepartamentos();
    this.adquirirTarefasDoCliente();
    this.adquirirStatus();
    document.addEventListener("click", this.onClickDocument);
    this._carregarListagemIndicadoresEmpresas(false);
    this.iniciarEventoDeScroll();
  },
  deactivated() {
    document.removeEventListener("click", this.onClickDocument);
    this.removerEventoDeScroll();
  },
  beforeUnmounted() {
    document.removeEventListener("click", this.onClickDocument);
    this.removerEventoDeScroll();
    this.abortarRequestsEmAndamento();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";
.modal-list-content {
  padding: 8px 35px;
  overflow:auto;
  height:100%;
}
.trf-simple-table {
  & th {
      position: sticky;
      background-color:var(--white, #FFF);
      border-bottom-width: 2px;
      top: 0;
      z-index: 21;
  }
  & .td-button {
      padding-left: 0;
      padding-right: 0;
  }
  & .td-button > button  {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
  }
  & .td-button > button a {
    color: $color-primary;
 }
  &  .td-button > .dropdown button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
  }
  & .dropdown-content > button {
    border: none;
    font-size: 14px;
    padding-right: 2rem;
  }
  & .dropdown-content {
    padding-bottom: 0.3em;
    padding-top: 0.25em;
  }
  & a.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
@media screen and (max-width: 1023px) {
  .columns.is-multiline {
    display:flex;
  }
}
</style>